import Loads from './loads';

export default Loads;
